import React from 'react';
import {
    BrowserRouter,
    Route,
    Switch,
} from 'react-router-dom';
import Loading from './components/shared/Loading';
const Account = React.lazy(() => import('./pages/account'));
const PatientPortal = React.lazy(() => import('./pages/patient-portal'));
// const PortalGateway = React.lazy(() => import('./pages/portal-gateway'));

const App: React.FC = React.memo(() => (
    <BrowserRouter>
        <React.Suspense fallback={<Loading />}>
            <Switch>
                <Route path="/account" component={Account} />
                {/* <Route path="/portal-gateway" component={PortalGateway} /> */}
                <Route path="/" component={PatientPortal} />
            </Switch>
        </React.Suspense>
    </BrowserRouter>
));

export default App;
